import React, { useContext } from 'react';
import AllhomesLogo from '@domain-group/fe-co-allhomes-logo';
import { slugify } from '@domain-group/fe-helper';
import { useAllhomesApi } from '@domain-group/fe-co-allhomes-api-client';
import { MediaContext } from 'react-media-query-hoc';
import { QuickLinksToggleButton } from './quick-links-toggle-button';
import { socialLinks } from '../utils/social-links';
import { toolbarLinks } from '../utils/toolbar-links';
import * as styles from './toolbar.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
export var AllhomesFooterToolbar = _ref => {
  var toggleQuickLinks = _ref.toggleQuickLinks,
    isQuickLinksShown = _ref.isQuickLinksShown,
    homepageLink = _ref.homepageLink;
  var _useContext = useContext(MediaContext),
    mobile = _useContext.mobile,
    tablet = _useContext.tablet,
    desktop = _useContext.desktop;
  var _useAllhomesApi = useAllhomesApi(),
    getAbsoluteUrl = _useAllhomesApi.getAbsoluteUrl;
  var renderNavItems = navItems => navItems.map(navItem => ___EmotionJSX("li", {
    key: slugify(navItem.text),
    css: styles.navItem
  }, ___EmotionJSX("a", {
    href: getAbsoluteUrl(navItem.href),
    css: styles.navLink
  }, navItem.text)));
  var renderSocialIcons = () => socialLinks.map(link => {
    var Icon = link.icon;
    return ___EmotionJSX("span", {
      key: link.text,
      css: styles.socialItem
    }, ___EmotionJSX("a", {
      href: link.href,
      title: link.text,
      css: styles.socialLink,
      "aria-label": link.text
    }, ___EmotionJSX(Icon, {
      css: styles.socialIcon,
      size: "small"
    })));
  });
  return ___EmotionJSX("div", {
    css: styles.toolbar
  }, ___EmotionJSX("div", {
    css: styles.innerWrap
  }, ___EmotionJSX("div", {
    css: styles.leftAligned
  }, desktop && ___EmotionJSX("div", {
    css: styles.logoContainer
  }, ___EmotionJSX("a", {
    href: getAbsoluteUrl(homepageLink),
    css: styles.toolbarLogo,
    "aria-label": "Allhomes Logo"
  }, ___EmotionJSX(AllhomesLogo, {
    colorScheme: "white"
  }))), ___EmotionJSX("ul", {
    css: styles.toolbarNavList,
    id: "navItems"
  }, renderNavItems(toolbarLinks))), ___EmotionJSX("div", {
    css: styles.rightAligned
  }, ___EmotionJSX("div", {
    css: styles.quickLinksContainer
  }, ___EmotionJSX("div", {
    css: styles.quickLinkSection
  }, ___EmotionJSX("div", {
    css: styles.socialList,
    id: "socialList"
  }, renderSocialIcons()))), (tablet || mobile) && ___EmotionJSX("div", {
    css: styles.quickLinkItem
  }, ___EmotionJSX(QuickLinksToggleButton, {
    toggleQuickLinks: toggleQuickLinks,
    isQuickLinksShown: isQuickLinksShown
  })))));
};